module.exports = __webpack_public_path__ + "img/win_s.195a51b6.gif";